<template>
  <div v-closable="onClose" class="w-select">
    <!-- Stupid method with using non multiple
      number of 4 but it's for consistency to the components -->
    <div
      :class="multiple ? 'py-[3px]' : 'py-[7px]'"
      class="w-select__selector"
      @click="toggleOpen(!showOptions)"
    >
      <div
        v-if="multiple && selectedItems.length"
        class="flex flex-wrap gap-1 items-center"
      >
        <div
          v-for="item in selectedItems"
          :key="`w-select-multiple-item-${item.key}`"
          :class="{ 'w-select__selector--multiple-item': multiple }"
          :disabled="disabled"
          :readonly="readonly"
          :tag="item"
        >
          <span>{{ item.value }}</span>
          <button class="ml-2" @click.prevent.stop="onSelect(item)">
            <i class="icon-circle-delete" />
          </button>
        </div>
      </div>
      <div
        v-else-if="!multiple && Object.keys(selectedItem).length"
        class="text-ellipsis truncate"
      >
        <span class="pl-2 text-ellipsis truncate">
          {{ selectedItem.label || selectedItem.value }}
        </span>
      </div>
      <span v-else class="pl-2 text-ellipsis text-gray-300 truncate">
        {{ placeholder || '請選擇' }}
      </span>
      <i class="ml-2 icon-down-chevron" />
    </div>
    <ul v-if="showOptions" class="w-select__options">
      <li
        v-for="option in newOptions"
        :key="`option-${option.key}`"
        :class="{
          'is-selected': hasSelected(option.key)
        }"
        class="w-select__options--option"
        @click="onSelect(option)"
      >
        <span>{{ option.value }}</span>
        <i
          v-if="showCheckedIcon && hasSelected(option.key)"
          class="icon-check-blue ml-2"
        />
      </li>
    </ul>
  </div>
</template>

<script>
import WSelect from './WSelect';

export default WSelect;
</script>

<style lang="scss" scoped>
@import 'WSelect';
</style>
